// todo: moveto API of reducers/emma-insurance
import { Mapping } from '../../../../types/Mapping';

// Use deepLink.query.disclaimer as key
export const ButtonBgColorMapping: Mapping = {
  sensely: '#43929D',
  'health-keeper': '#9190AC',
  cuhktourheart: '#FAD6DE',
  mindHealth: '#FCD385',
};
